// Import our custom CSS
import "../scss/styles.scss";

// Import only the Bootstrap components we need
import { Popover } from "bootstrap";

// Create an example popover
document.querySelectorAll('[data-bs-toggle="popover"]').forEach((popover) => {
  new Popover(popover);
});

/*  Placeholders in figma are having bold text within them.
  Such styles are not possible with scss. 
  So JS code is used here */
function textareaEventHandler(textarea, placeholder) {
  if (!textarea.value) placeholder.style.display = "block";
  else placeholder.style.display = "none";
}

function textareaJs() {
  const textareaWrappers = document.getElementsByClassName("textarea-wrapper");
  console.log("textareaWrappers", textareaWrappers);
  for (let i = 0; i < textareaWrappers.length; i += 1) {
    const wrapper = textareaWrappers[i];
    const textarea = wrapper.getElementsByTagName("textarea")[0];
    console.log("textarea", textarea.addEventListener);
    const placeholder = wrapper.getElementsByClassName(
      "textarea-placeholder"
    )[0];
    textarea.addEventListener("focus", (e) =>
      textareaEventHandler(textarea, placeholder)
    );
    textarea.addEventListener("blur", (e) =>
      textareaEventHandler(textarea, placeholder)
    );
    textarea.addEventListener("input", (e) =>
      textareaEventHandler(textarea, placeholder)
    );
  }
}

textareaJs();

